(function (w) {

    function FinanceProvidersFormViewModel(model, requireAddress, getStatesUrl, fieldsToValidate) {

        const self = this;

        fieldsToValidate = fieldsToValidate ?? { FinanceRequired: true };

        //#region Form fields

        var requiresValidation = (fieldName) => { return fieldsToValidate[fieldName] ?? false; };

        self.Name = ko.observable(model.Name).extend({ required: true });

        self.Email = ko.observable(model.Email).extend({ required: true, email: true });

        self.Telephone = ko.observable(model.Telephone ? model.Telephone : '').extend({ required: true });
        self.AddressLine1 = ko.observable(model.AddressLine1).extend({ required: requireAddress || requiresValidation('AddressLine1') });
        self.AddressLine2 = ko.observable(model.AddressLine2);
        self.Postcode = ko.observable(model.Postcode).extend({ required: requireAddress || requiresValidation('Postcode'), maxLength: 20 });
        self.City = ko.observable(model.City).extend({ required: requireAddress || requiresValidation('City') });

        self.States = ko.observableArray([]); // State dropdown options
        self.StateIsRequired = function () { return (requireAddress || requiresValidation('State')) && self.States().length; };
        self.State = ko.observable(model.StateId ? model.StateId : '').extend({ required: { onlyIf: self.StateIsRequired } });

        self.CountryId = ko.observable("" + model.CountryId);

        self.DialCodes = ko.observableArray([]); // Dial codes dropdown options
        self.DialCode = ko.observable();

        self.Message = ko.observable(model.Message);
        self.PurchasePrice = ko.observable(model.PurchasePrice);
        self.FinanceRequired = ko.observable(model.FinanceRequired).extend({ required: requiresValidation('FinanceRequired') });

        //#endregion

        self.CookieDomain = '';

        //#region Address finders

        self.ShowAddressFields = ko.observable(false); // If false, only show address finders; if true, show all fields for manual input
        self.ShowSelectedAddress = ko.observable(false); // If true, show selected address as text (no inputs)

        self.CountryId.subscribe(function () {
            self.ShowSelectedAddress(false);
            self.StateSelectedAutomatically(false);
        });

        self.AddAddressManually = function () {
            self.ShowAddressFields(true);
            self.ShowSelectedAddress(false);
            self.StateSelectedAutomatically(false);
        };

        self.ClearAddressFields = function () {
            self.AddressLine1('');
            self.AddressLine2('');
            self.City('');
            self.Postcode('');
            self.State(null);
        };

        //#region Google address search

        self.AddressAutoCompleteCountryCode = ko.observable(null); // Passed to google to narrow down the autocomplete to the selected country

        self.OnAddressAutoCompleteSelected = function (element, autoCompletedPlace) {

            console.log(autoCompletedPlace);

            // Clear the calling element value
            $(element).val('');

            let entityName = "";
            let postbox = "";
            let subpremise = "";
            let floor = "";
            let addressLineWithStreetNumber = "";
            let streetNumber = "";
            let addressLinePriority1 = "";
            let addressLinePriority2 = "";
            let city = "";
            let postcode = "";
            let stateId = "";

            // Clear all the Address Fields
            self.ClearAddressFields();

            // Get the Lat and lng of the chosen address for our own records 
            if (autoCompletedPlace.geometry) {
                self.latitude = autoCompletedPlace.geometry.location.lat();
                self.longitude = autoCompletedPlace.geometry.location.lng();
            }

            // Loop through each 
            for (let ac = 0; ac < autoCompletedPlace.address_components.length; ac++) {

                const addressComponent = autoCompletedPlace.address_components[ac];

                for (let t = 0; t < addressComponent.types.length; t++) {

                    if (addressComponent.types[t] === "point_of_interest") {
                        entityName = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "establishment") {
                        entityName = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "post_box") {
                        postbox = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "subpremise") {
                        subpremise = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "floor") {
                        floor = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "street_number") {
                        streetNumber = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "street_address") {
                        addressLineWithStreetNumber = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "route") {
                        addressLinePriority1 = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "sublocality") {
                        addressLinePriority2 = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "sublocality_level_1") {
                        addressLinePriority2 = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "neighborhood" && addressLinePriority2 === '') {
                        addressLinePriority2 = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "locality") {
                        city = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "postal_town") {
                        if (city !== '' && city !== addressComponent.long_name && addressLinePriority2 === '') {
                            addressLinePriority2 = city;
                        }
                        city = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "postal_code") {
                        postcode = addressComponent.long_name;
                    }

                    if (addressComponent.types[t].startsWith("administrative_area") || addressComponent.types[t] === "postal_town" || addressComponent.types[t] === "political") {
                        $("#stateIdSelect").find("option").each(function () {
                            if ($(this).text().toLowerCase() === addressComponent.long_name.toLowerCase()) {
                                stateId = $(this).attr("value");
                            }
                        });
                    }
                }
            }

            let addressLine1 = "";
            if (addressLineWithStreetNumber !== '') {
                addressLine1 = addressLineWithStreetNumber;
            }
            else if (addressLinePriority1 !== '') {
                addressLine1 = (streetNumber !== '' ? streetNumber + ' ' : '') + addressLinePriority1;
            }
            if (floor !== '') {
                addressLine1 = floor + ', ' + addressLine1;
            }
            if (subpremise !== '') {
                addressLine1 = subpremise + ', ' + addressLine1;
            }
            if (postbox !== '') {
                addressLine1 = postbox + ', ' + addressLine1;
            }

            let addressLine2 = addressLinePriority2;
            if (entityName !== '') {
                addressLine2 = addressLine1;
                addressLine1 = entityName;
            }

            // Add First Line to the first street address line
            if (addressLine1 !== '') {
                self.AddressLine1(addressLine1);
            }

            // Add the second address line to the first address line object the first address line wasn't set for some reason. 
            // Otherwise, add a new item in the street address array
            if (addressLine2 !== '') {
                if (!self.AddressLine1()) {
                    self.AddressLine1(addressLine2);
                }
                else {
                    self.AddressLine2(addressLine2);
                }
            }

            // Set city and postcode
            self.City(city);
            self.Postcode(postcode);
            if (stateId) {
                self.State(stateId);
                self.StateSelectedAutomatically(true);
            } else {
                self.StateSelectedAutomatically(false);
            }

            if (addressLine1 !== '' && city !== '' && postcode !== '' && (!self.StateIsRequired() || stateId)) {
                // If we have all the required address fields, show the box with the selected address
                self.ShowSelectedAddress(true);
                self.ShowAddressFields(false);
            }
            else {
                // Show the address fields
                self.ShowSelectedAddress(false);
                self.ShowAddressFields(true);
            }
        };

        //#endregion

        //#endregion

        //#region Small helpers

        self.StateSelectedAutomatically = ko.observable(false); // Indicates if state was autoselected by OnAddressAutoCompleteSelected

        self.CountryFilterText = ko.observable(''); // Country dropdown filter input

        // Helper to display selected state name
        self.SelectedStateName = ko.pureComputed(function () {
            const stateId = self.State();
            const states = self.States();
            if (stateId && states && states.length) {
                for (let i = 0; i < states.length; i++) {
                    if (states[i].stateId == stateId) {
                        return states[i].stateName;
                    }
                }
            }
            return '';
        });

        // Automatically update dial code when country changes
        self.CountryId.subscribe(function (countryId) {
            if (countryId) {
                const dialCodes = self.DialCodes();
                if (dialCodes && dialCodes.length) {
                    for (let i = 0; i < dialCodes.length; i++) {
                        const dialCode = dialCodes[i];
                        if (dialCode.CountryId == countryId) {
                            self.DialCode(dialCode);
                            self.AddressAutoCompleteCountryCode(dialCode.CountryCode);
                        }
                    }
                }
            }
        });

        //#endregion

        //#region Getting states for selected country

        self.GetStates = function (countryId, retryCount) {

            if (retryCount && retryCount > 2)
                return;

            if (!countryId || countryId < 0)
                return;

            self.State('');
            $.ajax({
                url: getStatesUrl.replace("1138", countryId),
                method: 'GET'
            }).done(function (response) {
                self.States(response);
            }).fail(function () {
                retryCount = retryCount || 0;
                self.GetStates(countryId, retryCount + 1);
            });
        };

        // Initialization:
        if (requireAddress || requiresValidation('State')) {
            self.CountryId.subscribe(self.GetStates);
            const countryId = self.CountryId();
            if (countryId && countryId > 0) {
                self.GetStates(countryId);
            }
        }

        //#endregion

        //#region Validation helpers (for 'error' class support on top of validationMessage bindings)

        self.Validateables = [
            { key: 'Name', value: self.Name },
            { key: 'FinanceRequired', value: self.FinanceRequired },
            { key: 'CountryId', value: self.CountryId },
            { key: 'Email', value: self.Email },
            { key: 'Telephone', value: self.Telephone },
            { key: 'AddressLine1', value: self.AddressLine1 },
            { key: 'AddressLine2', value: self.AddressLine2 },
            { key: 'Postcode', value: self.Postcode },
            { key: 'City', value: self.City },
            { key: 'State', value: self.State }
        ];


        // This array will hold Validateables keys (e.g. ['Name','Email']) for which we can display an error
        self.InvalidKeys = ko.observableArray([]);

        // This function goes through the InvalidKeys array to check if they are still invalid
        // This is because some validateables may affect others - e.g. changing the country may affect the state dropdown.
        self.RecheckInvalidKeys = function () {
            const invalidKeys = self.InvalidKeys();
            //for each invalid key...
            for (let i = invalidKeys.length - 1; i >= 0; i--) {
                const invalidKey = invalidKeys[i];
                //find its relevant validateable...
                for (let j = 0; j < self.Validateables.length; j++) {
                    const validateable = self.Validateables[j];
                    if (validateable.key === invalidKey) {
                        //and check if it's still invalid
                        const error = ko.validation.group(validateable.value);
                        if (error().length === 0) {
                            //remove from InvalidKeys array if it's not invalid anymore
                            self.InvalidKeys.remove(validateable.key);
                        }
                    }
                }
            }
        };

        // For each validateable, add a subscription that updates InvalidKeys array when necessary:
        for (let i = 0; i < self.Validateables.length; i++) {
            const validateable = self.Validateables[i];

            validateable.value.subscribe(function (val) {
                // Whenever a validateable value is updated, check if it should be added to or removed from InvalidKeys
                const error = ko.validation.group(validateable.value);
                if (error().length === 0) {
                    self.InvalidKeys.remove(validateable.key);
                } else if (self.InvalidKeys().indexOf(validateable.key) < 0) {
                    self.InvalidKeys.push(validateable.key);
                }
                // And since they can affect each other, recheck invalid keys (maybe some became valid because of this new change)
                self.RecheckInvalidKeys();
            });
        }

        // Each key also gets their own pureComputed to check if there's an error with it. Usage: data-bind="visible: IsInvalid('Name')()"
        self.IsInvalid = function (key) {
            return ko.pureComputed(function () { return self.InvalidKeys().indexOf(key) >= 0; });
        };

        //#endregion

        //#region Form submit

        self.IsFormSubmitting = ko.observable(false);
        self.IsFormSubmitted = ko.observable(false);
        self.TrySubmit = function () {

            // When submitting, check if there are any errors first:

            // Refresh InvalidKeys array (to display correct error classes)
            for (let i = 0; i < self.Validateables.length; i++) {
                const validateable = self.Validateables[i];
                const error = ko.validation.group(validateable.value);
                if (error().length === 0) {
                    self.InvalidKeys.remove(validateable.key);
                } else if (self.InvalidKeys().indexOf(validateable.key) < 0) {
                    self.InvalidKeys.push(validateable.key);
                }
            }

            // Do validation
            const errors = ko.validation.group(self);
            if (errors().length) {

                // If we have errors, show all address fields so the user has a clear view of all things missing
                self.AddAddressManually();

                // Show all errors messages, then scroll to first error
                errors.showAllMessages();
                setTimeout(function () {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".error").first().offset().top
                    }, 1000);
                }, 100);

                // Don't submit form
                return false;
            }

            // No errors, so return true to submit form:
            return true;
        };

        //#endregion
    }

    w.financeProvidersFormViewModel = FinanceProvidersFormViewModel;

})(window);